import React from 'react';
import { Button } from 'primereact/button';
import { Image } from 'primereact/image';


import Logo from '../assets/logo-horizontal.png';
import Ceasa from '../assets/logo_patos.png';

export const HeaderHome = ({ exbirEntrar = true }) => {

    return (
        <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '0.4em',
            backgroundColor: '#ffffff',
            height: '5em',
            boxShadow: '0 0.4em 0.8em rgba(0, 0, 0, 0.1)'
        }}>
            <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between'
            }} >
                <Image
                    src={Logo}
                    width='100%'
                    height='auto'
                    alt='Logo'
                />
                <Image
                    src={Ceasa}
                    alt='Ceasa'
                    style={{
                        width: '70px',  // Ajuste a largura conforme necessário
                        height: 'auto',  // Mantém a proporção da altura
                        padding: '5px',  // Adiciona 3px de espaço nas margens da imagem                    
                    }}

                />
            </div>
            { exbirEntrar &&

            <Button label='Entrar' icon="pi pi-sign-in" onClick={() => window.open('/login', '_self')}
                style={{
                    marginRight: '0.8em',
                    backgroundColor: '#172554',
                    fontSize: '1.2rem',
                    fontWeight: 'bold',
                    border: 'none',
                    height: '2.5em'
                }} />
            }

        </div>
    );
};

export default HeaderHome;